import "babel-polyfill";
import "./configure";
import "./polyfills";
import "./main.css";
import renderBrowser from "./renderBrowser";

if (typeof document !== "undefined") {
  renderBrowser();
}
